import { api } from '../api/endpoints.js';
import { haptic } from '../tg.js';

// Leaderboard bottom sheet.
//   const result = await openLeaderboardSheet(parent);
//   result.status: 'closed'
//
// Shows top 50 by high_score + user's own rank sticky at bottom.
export function openLeaderboardSheet(parent) {
  return new Promise((resolve) => {
    const el = document.createElement('div');
    el.className = 'modal-overlay sheet-overlay';
    el.innerHTML = `
      <div class="sheet sheet-lb">
        <div class="sheet-handle"></div>
        <div class="sheet-header">
          <div class="sheet-title">LEADERBOARD</div>
          <div class="sheet-sub">Top 50 · High score</div>
        </div>
        <div class="sheet-body lb-body" id="lb-body">
          <div class="sheet-loading">Loading…</div>
        </div>
        <div class="lb-me" id="lb-me" hidden></div>
        <button class="sheet-close">Close</button>
      </div>`;
    parent.appendChild(el);

    const sheetEl = el.querySelector('.sheet');
    requestAnimationFrame(() => sheetEl.classList.add('show'));

    const body = el.querySelector('#lb-body');
    const meEl = el.querySelector('#lb-me');

    const close = () => {
      if (sheetEl.classList.contains('closing')) return;
      sheetEl.classList.add('closing');
      setTimeout(() => { el.remove(); resolve({ status: 'closed' }); }, 220);
    };

    el.querySelector('.sheet-close').onclick = close;
    el.onclick = (ev) => { if (ev.target === el) close(); };

    api.getLeaderboard().then((data) => {
      const top = data?.top || [];
      const me = data?.me || { rank: 0, high_score: 0 };

      if (top.length === 0) {
        body.innerHTML = `<div class="sheet-empty">No champions yet — be the first!</div>`;
      } else {
        body.innerHTML = top.map((e) => {
          const medal = e.rank === 1 ? '🥇' : e.rank === 2 ? '🥈' : e.rank === 3 ? '🥉' : '';
          return `
            <div class="lb-row ${e.is_me ? 'me' : ''}">
              <div class="lb-rank">${medal || `#${e.rank}`}</div>
              <div class="lb-name">${escapeHtml(e.name || 'Player')}</div>
              <div class="lb-score">${e.high_score.toLocaleString()}</div>
            </div>`;
        }).join('');
      }

      // Show "me" sticky if user has a rank and isn't already in top 50.
      const meInTop = top.some((e) => e.is_me);
      if (me.rank > 0 && !meInTop) {
        meEl.hidden = false;
        meEl.innerHTML = `
          <div class="lb-row me">
            <div class="lb-rank">#${me.rank}</div>
            <div class="lb-name">YOU</div>
            <div class="lb-score">${me.high_score.toLocaleString()}</div>
          </div>`;
      } else if (me.rank === 0) {
        meEl.hidden = false;
        meEl.innerHTML = `<div class="lb-empty-me">Play a round to enter the leaderboard</div>`;
      }
    }).catch((e) => {
      haptic('error');
      body.innerHTML = `<div class="sheet-error">${e?.message || 'Failed to load'}</div>`;
    });
  });
}

function escapeHtml(s) {
  return String(s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
